// auth.js - Authentication Helper Functions

export const isAuthenticated = () => {
    return localStorage.getItem("token") !== null; // If token exists, user is authenticated
};

export const login = (token) => {
    localStorage.setItem("token", token); // Store auth token
};

export const logout = () => {
    localStorage.removeItem("token"); // Remove auth token
};
